import { getLiveModelYears } from "./vapiService.js";

// Every live vehicle-year, as [{ model, year }]. One cache entry shared by the nav
// menu and the towing calculator, so a page asks for it once.
export const liveModelYearsQuery = () => ({
  queryKey: ["liveModelYears"],
  queryFn: () => getLiveModelYears(),
  staleTime: 30 * 60 * 1000,
  gcTime: 60 * 60 * 1000,
});
